import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloseIcon from "../../../../assets/images/plus-circle-fill.svg";
import launchFormService from "../../../../services/launchForm.service";
import * as Util from "../../../../services/global.service";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import angry from "../../../../assets/images/angry.png";
import bored from "../../../../assets/images/bored.png";
import lazy from "../../../../assets/images/lazy.png";
import worried from "../../../../assets/images/worried.png";
import disappointed from "../../../../assets/images/disappointed.png";
import accomplished from "../../../../assets/images/accomplished.png";
import loved from "../../../../assets/images/loved.png";
import joyful from "../../../../assets/images/joyful.png";
import happy from "../../../../assets/images/happy.png";
import excited from "../../../../assets/images/excited.png";
import { ReactComponent as Hashtag } from "../../../../assets/images/hashtag.svg";
import { ReactComponent as TrashRed20 } from "../../../../assets/images/trashRed20.svg";
import myFeedback from "../../../../services/myFeedback.service";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from "@mui/styles";
const useStyles = makeStyles({
});


const DefaultForm = (props) => {
  const { open, close, data, openSuccessAddDialog, dataGetDetail, } = props
  const classes = useStyles();
  const { t } = useTranslation()
  const [discardDialog, setDiscardDialog] = React.useState(false);
  let [list, setList] = React.useState({});
  const handleCloseDialog = () => {
    close(false);
  };

  useEffect(() => {
    if (open) {
      getFeedback()
    }
  }, [open]);

  const getFeedback = () => {
    if (Util.formatData(dataGetDetail?.serial, false) !== false && Util.formatData(dataGetDetail?.emp_id, false) !== false) {
      myFeedback.getFeedback(dataGetDetail?.serial, dataGetDetail?.emp_id).then((rs) => {
        setList(rs?.data)
      })
    }
  };

  let submit = () => {
    if (Util.formatData(dataGetDetail?.serial, false) !== false && Util.formatData(dataGetDetail?.owner?.serial, false) !== false && Util.formatData(dataGetDetail?.selectEmployee?.serial, false) !== false && dataGetDetail?.owner?.serial === dataGetDetail?.selectEmployee?.serial) {
      myFeedback.deleteFeedback(dataGetDetail?.serial).then((rs) => {
        openSuccessAddDialog()
      })
    }
  }

  const handleDiscardChangeConfirm = () => {
    handleDiscardDialog(false)
    submit()
  };
  const handleDiscardDialog = (value) => {
    setDiscardDialog(value)
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));
  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '20px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" fontWeight="600" sx={{ padding: "0 0 20px" }}>
        {t('feedback.label.feedbackDetail')}
        <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0", "overflow-y": "unset" }}>
        <Box sx={{ pt: "20px" }}>
          {dataGetDetail?.type === "received" ?
            <Box sx={{ display: "flex", maxHeight: Util.formatData(dataGetDetail?.owner?.serial, false) !== false && Util.formatData(dataGetDetail?.selectEmployee?.serial, false) !== false && dataGetDetail?.owner?.serial === dataGetDetail?.selectEmployee?.serial ? "calc(100vh - 245px)" : "calc(100vh - 190px)", overflowY: "auto" }}>
              <Box sx={{ width: "100%" }} >
                <Box sx={{ alignItems: "center", display: "flex", }}>
                  <Box sx={{ alignItems: "center", display: "flex", width: "calc(100% - 60px)" }} pr="10px">
                    <Avatar
                      src={dataGetDetail?.employee?.photo}
                      sx={{
                        width: 40,
                        height: 40,
                      }}
                    >
                    </Avatar>
                    <Box pl="10px" width="calc(100% - 40px)">
                      <Typography color="#404349" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataGetDetail?.employee?.fullname}</Typography>
                      <Typography color="#888F9D" fontSize={13} lineHeight="19.44px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataGetDetail?.employee?.position}<span style={{ color: "#BEC2CB", "font-size": "13px", "line-height": "19.44px", padding: "0 10px", }}>|</span> <span style={{ display: "inline-flex", "vertical-align": "middle", cursor: "pointer" }}><BootstrapTooltip title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{t('feedback.label.question')}: {Util.formatData(dataGetDetail?.total_question, 0)}</span>} placement="top" ><Hashtag style={{ "margin-top": "-1px", "margin-right": "5px" }} /></BootstrapTooltip></span>{Util.formatData(dataGetDetail?.total_question, 0)}</Typography>
                    </Box>
                  </Box>
                  <Box width="60px">
                    <Typography color="#AAAAAA" pt="5px" textAlign="end" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{Util.dateDayFormatAdmin(dataGetDetail?.date)}</Typography>
                  </Box>
                </Box>
                <Typography color="#404349" py="10px" fontSize={18} lineHeight="26.91px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataGetDetail?.title}</Typography>
                {Util.formatData(list?.feedback_question, [].length > 0) ?
                  list?.feedback_question.map((data, idx) =>
                    Util.formatData(data?.emotion, false) !== false || Util.formatData(data?.comment, false) !== false ?
                      <Box>
                        <Typography fontWeight="500" color="#5DA196" fontSize={14} lineHeight="20.93px" sx={{ width: "calc(100% - 15px)", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content" }} >Q{idx + 1}:<span style={{ "padding-left": "5px" }}>{data?.question}</span></Typography>
                        <Box pt="10px" pb="15px">
                          <Box sx={{ display: "flex", width: "calc(100% - 28px)" }}>
                            <Avatar
                              src={list?.employee?.photo}
                              sx={{
                                width: 30,
                                height: 30,
                              }}
                            >
                            </Avatar>

                            <Box pl="10px" width="calc(100% - 30px)">
                              <Typography color="#888F9D" fontWeight="400" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{list?.employee?.fullname}</Typography>
                              {Util.formatData(data?.emotion, false) !== false ?
                                <Box pt="5px">
                                  <BootstrapTooltip title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{data?.emotion === "angry" ? t('feedback.label.angry') : data?.emotion === "bored" ? t('feedback.label.bored') : data?.emotion === "lazy" ? t('feedback.label.lazy') : data?.emotion === "worried" ? t('feedback.label.worried') : data?.emotion === "disappointed" ? t('feedback.label.disappointed') : data?.emotion === "accomplished" ? t('feedback.label.accomplished') : data?.emotion === "loved" ? t('feedback.label.loved') : data?.emotion === "joyful" ? t('feedback.label.joyful') : data?.emotion === "happy" ? t('feedback.label.happy') : data?.emotion === "excited" ? t('feedback.label.excited') : "-"}</span>} placement="top">
                                    <img width="60px" height="60px" src={data?.emotion === "angry" ? angry : data?.emotion === "bored" ? bored : data?.emotion === "lazy" ? lazy : data?.emotion === "worried" ? worried : data?.emotion === "disappointed" ? disappointed : data?.emotion === "accomplished" ? accomplished : data?.emotion === "loved" ? loved : data?.emotion === "joyful" ? joyful : data?.emotion === "happy" ? happy : data?.emotion === "excited" ? excited : ""} alt={data?.emotion === "angry" ? angry : data?.emotion === "bored" ? bored : data?.emotion === "lazy" ? lazy : data?.emotion === "worried" ? worried : data?.emotion === "disappointed" ? disappointed : data?.emotion === "accomplished" ? accomplished : data?.emotion === "loved" ? loved : data?.emotion === "joyful" ? joyful : data?.emotion === "happy" ? happy : data?.emotion === "excited" ? excited : ""} />
                                  </BootstrapTooltip>
                                </Box>
                                :
                                null
                              }
                              {Util.formatData(data?.comment, false) !== false ?
                                <Box p="10px 15px" mt="5px" backgroundColor="#EFF6F4" borderRadius="0px 20px 20px 20px" sx={{ width: "max-content", maxWidth: " 100%" }}>
                                  <Typography color="#404349" fontWeight="400" fontSize={16} lineHeight="23.92px" >{Util.formatData(data?.comment, "-")}</Typography>
                                </Box>
                                :
                                null
                              }
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      :
                      null
                  )
                  :
                  null
                }
              </Box>
            </Box>
            : dataGetDetail?.type === "given" ?
              <Box sx={{ display: "flex", maxHeight: Util.formatData(dataGetDetail?.owner?.serial, false) !== false && Util.formatData(dataGetDetail?.selectEmployee?.serial, false) !== false && dataGetDetail?.owner?.serial === dataGetDetail?.selectEmployee?.serial ? "calc(100vh - 245px)" : "calc(100vh - 190px)", overflowY: "auto" }}>
                <Box sx={{ width: "100%" }} >
                  <Box sx={{ alignItems: "center", display: "flex", }}>
                    <Box sx={{ alignItems: "center", display: "flex", width: "calc(100% - 60px)" }} pr="10px">
                      <Avatar
                        src={dataGetDetail?.employee?.photo}
                        sx={{
                          width: 40,
                          height: 40,
                        }}
                      >
                      </Avatar>
                      <Box pl="10px" width="calc(100% - 40px)">
                        <Typography color="#404349" fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataGetDetail?.employee?.fullname}</Typography>
                        <Typography color="#888F9D" fontSize={13} lineHeight="19.44px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataGetDetail?.employee?.position}<span style={{ color: "#BEC2CB", "font-size": "13px", "line-height": "19.44px", padding: "0 10px", }}>|</span> <span style={{ display: "inline-flex", "vertical-align": "middle", cursor: "pointer" }}><BootstrapTooltip title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{t('feedback.label.question')}: {Util.formatData(dataGetDetail?.total_question, 0)}</span>} placement="top" ><Hashtag style={{ "margin-top": "-1px", "margin-right": "5px" }} /></BootstrapTooltip></span>{Util.formatData(dataGetDetail?.total_question, 0)}</Typography>
                      </Box>
                    </Box>
                    <Box width="60px">
                      <Typography color="#AAAAAA" pt="5px" textAlign="end" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{Util.dateDayFormatAdmin(dataGetDetail?.date)}</Typography>
                    </Box>
                  </Box>
                  <Typography color="#404349" py="10px" fontSize={18} lineHeight="26.91px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataGetDetail?.title}</Typography>
                  {Util.formatData(list?.feedback_question, [].length > 0) ?
                    list?.feedback_question.map((data, idx) =>
                      Util.formatData(data?.emotion, false) !== false || Util.formatData(data?.comment, false) !== false ?
                        <Box>
                          <Typography fontWeight="500" color="#5DA196" fontSize={14} lineHeight="20.93px" sx={{ width: "calc(100% - 15px)", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content" }} >Q{idx + 1}:<span style={{ "padding-left": "5px" }}>{data?.question}</span></Typography>
                          <Box pt="10px" pb="15px">
                            <Box sx={{ display: "flex", width: "calc(100% - 28px)" }}>
                              <Avatar
                                src={list?.employee?.photo}
                                sx={{
                                  width: 30,
                                  height: 30,
                                }}
                              >
                              </Avatar>

                              <Box pl="10px" width="calc(100% - 30px)">
                                <Typography color="#888F9D" fontWeight="400" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{list?.employee?.fullname}</Typography>
                                {Util.formatData(data?.emotion, false) !== false ?
                                  <Box pt="5px">
                                    <BootstrapTooltip title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{data?.emotion === "angry" ? t('feedback.label.angry') : data?.emotion === "bored" ? t('feedback.label.bored') : data?.emotion === "lazy" ? t('feedback.label.lazy') : data?.emotion === "worried" ? t('feedback.label.worried') : data?.emotion === "disappointed" ? t('feedback.label.disappointed') : data?.emotion === "accomplished" ? t('feedback.label.accomplished') : data?.emotion === "loved" ? t('feedback.label.loved') : data?.emotion === "joyful" ? t('feedback.label.joyful') : data?.emotion === "happy" ? t('feedback.label.happy') : data?.emotion === "excited" ? t('feedback.label.excited') : "-"}</span>} placement="top">
                                      <img width="60px" height="60px" src={data?.emotion === "angry" ? angry : data?.emotion === "bored" ? bored : data?.emotion === "lazy" ? lazy : data?.emotion === "worried" ? worried : data?.emotion === "disappointed" ? disappointed : data?.emotion === "accomplished" ? accomplished : data?.emotion === "loved" ? loved : data?.emotion === "joyful" ? joyful : data?.emotion === "happy" ? happy : data?.emotion === "excited" ? excited : ""} alt={data?.emotion === "angry" ? angry : data?.emotion === "bored" ? bored : data?.emotion === "lazy" ? lazy : data?.emotion === "worried" ? worried : data?.emotion === "disappointed" ? disappointed : data?.emotion === "accomplished" ? accomplished : data?.emotion === "loved" ? loved : data?.emotion === "joyful" ? joyful : data?.emotion === "happy" ? happy : data?.emotion === "excited" ? excited : ""} />
                                    </BootstrapTooltip>
                                  </Box>
                                  :
                                  null
                                }
                                {Util.formatData(data?.comment, false) !== false ?
                                  <Box p="10px 15px" mt="5px" backgroundColor="#EFF6F4" borderRadius="0px 20px 20px 20px" sx={{ width: "max-content", maxWidth: " 100%" }}>
                                    <Typography color="#404349" fontWeight="400" fontSize={16} lineHeight="23.92px" >{Util.formatData(data?.comment, "-")}</Typography>
                                  </Box>
                                  :
                                  null
                                }
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        :
                        null
                    )
                    :
                    null
                  }
                </Box>
              </Box>
              :
              null
          }
          {Util.formatData(dataGetDetail?.owner?.serial, false) !== false && Util.formatData(dataGetDetail?.selectEmployee?.serial, false) !== false && dataGetDetail?.owner?.serial === dataGetDetail?.selectEmployee?.serial && false ?
            <Button sx={{ display: "flex", height: "45px", "text-transform": "none", borderColor: "#CC6058 !important", margin: "10px auto 0", }} variant="dashed-solid-primary" onClick={e => handleDiscardDialog(true)} ><Box sx={{ display: "flex", "align-items": "center" }}><TrashRed20 /><Typography ml="10px" color="#CC6058">{t('feedback.label.deleteFeedback')}</Typography></Box></Button>
            :
            null
          }
        </Box>
      </DialogContent>
      <ConfirmDialog open={discardDialog} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationofDeletion')} text={t('feedback.label.areYouSureYouWantToDeleteThisFeedback')} />
    </Dialog >
  );
};
export default DefaultForm;
